module.exports = __webpack_public_path__ + "img/shoubing.prt.a56db4ad.jpg";